<template>
    <div>
        <div class="col-sm-12">

            <!-- Invoice To Selctor -->
            <div class="mt-2 d-flex">
                <button @click="setInvoiceTo('customer')" :disabled="true" :class="{'blue': invoiceTo == 'customer'}" class="btn tertiary full super mr-3">Customer (coming soon)</button>
                <button @click="setInvoiceTo('agent')" :class="{'blue': invoiceTo == 'agent'}" class="btn tertiary full super">Agent</button>
            </div>

            <!-- Value to invoice & Agent Picker -->
            <div class="mt-2 d-flex justify-content-between" v-if="invoiceTo">
                <div>
                    <seller-picker
                        v-if="invoiceTo == 'agent'"
                        :changeReservationSeller="false"
                        :showMyTeam="false"
                        :inlcudeWidget="false"
                        @input="sellerChanged">
                    </seller-picker>
                </div>
                <div v-if="invoiceResumeBulk">
                    <label>
                        Amount to invoice
                    </label>
                    <div v-if="getIsDownloadingInvoiceResumeBulk">
                        <loader></loader>
                    </div>
                    <div v-else class="fs-large text-right darker bold">{{formatPrice(valueToInvoice)}}€</div>
                </div>
            </div>

            <!-- Billing Info Form -->
            <div v-if="invoiceTo" class="row mt-2">

                <div class="col-sm-4">
                    <label :class="{'color-6':$v.invoiceToForm.vat.$invalid}">
                        VAT Number
                    </label>
                    <input type="text" class="full mb-3" v-model="invoiceToForm.vat">
                </div>

                <div class="col-sm-4">
                    <label :class="{'color-6':$v.invoiceToForm.city.$invalid}">
                        City <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>
                    <input type="text" class="full mb-3" v-model="invoiceToForm.city">
                </div>

                <div class="col-sm-4">
                    <label :class="{'color-6':$v.invoiceToForm.country.$invalid}">
                        Country <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>
                    <v-select :options="getCountries" v-model="selectedCountry" placeholder="Select Country" label="name" @input="selectedCountryChanged"></v-select>
                </div>

                <div class="col-sm-6">
                    <label :class="{'color-6':$v.invoiceToForm.businessName.$invalid}">
                        Billing name
                    </label>
                    <input type="text" class="full mb-3" v-model="invoiceToForm.businessName">
                </div>

                <div class="col-sm-6">
                    <label :class="{'color-6':$v.invoiceToForm.address.$invalid}">
                        Address <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>
                    <input type="text" class="full mb-3" v-model="invoiceToForm.address">
                </div>

            </div>

            <div class="d-flex  align-items-center my-3" v-if="invoiceTo">
                <div class="flexGrow1 d-flex">
                    <div v-if="getIsPrintingInvoice" class="d-flex">
                        <loader></loader>
                        <div>Downloading invoice please wait</div>
                    </div>
                </div>
                <button class="btn blue widest" :disabled="getIsCreatingInvoice || $v.$invalid || getIsPrintingInvoice" @click="emitInvoices">Invoice</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import SellerPicker from '@/tools/SellerPicker'
    import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators'
    import Loader from '@/tools/loaders/loader1'

    export default {
        created: function(){
            // this.selectedAgent = this.getAgents[0]

            this.getInvoiceResume()
        },
        props: {
            bulkObject: {
                type: Object
            }
        },
        data: function() {
            return {
                invoiceTo: null,
                selectedCountry: null,
                selectedAgent: null,
                invoiceToForm: {
                    id: null,
                    vat: null,
                    city: null,
                    country: null,
                    businessName: null,
                    address: null
                },
                invoiceResumeBulk: null
            }
        },
        computed: {
            ...mapGetters([
                'getCountries',
                'getAgents',
                'getIsDownloadingInvoiceResumeBulk',
                'getValueToAskMoreBillingInfo',
                'getIsCreatingInvoice',
                'getIsPrintingInvoice'
            ]),
            isInvoiceValueOver: function () {
                return this.valueToInvoice > this.getValueToAskMoreBillingInfo
            },
            valueToInvoice: function () {
                if(this.getIsDownloadingInvoiceResumeBulk || !this.invoiceResumeBulk){
                    return false
                }

                if(this.invoiceTo == 'customer'){
                    return this.invoiceResumeBulk.invoiceRequestCustomer.total
                } else if (this.invoiceTo == 'agent') {
                    return this.invoiceResumeBulk.invoiceRequestAgent.total
                }
            },
        },
        validations:{
            invoiceToForm: {
                vat: {
                    // required
                },
                city: {
                    required: requiredIf(function () { return this.isInvoiceValueOver })
                },
                country: {
                    required: requiredIf(function () { return this.isInvoiceValueOver })
                },
                businessName: {
                    // required
                },
                address: {
                    required: requiredIf(function () { return this.isInvoiceValueOver })
                }
            },
        },
        methods: {
            ...mapActions([
                'emitInvoiceBulk',
                'downloadReservationInvoiceResumeBulk',
                'printInvoice'
            ]),
            setInvoiceTo: function (newInvoiceTo) {
                this.invoiceTo = newInvoiceTo

                if(newInvoiceTo == 'customer'){
                    this.fillFormWithCustomer()
                } else if (newInvoiceTo == 'agent') {
                    this.fillFormWithAgent(this.selectedAgent)
                }
            },
            fillFormWithCustomer: function () {
                // if(this.reservation.billing.details){
                //     this.invoiceToForm = this.reservation.billing.details
                //     this.setCountry()
                // }
                this.invoiceToForm = {
                    id: null,
                    vat: null,
                    city: null,
                    country: 176,
                    businessName: null,
                    address: null,
                }
                this.setCountry()
            },
            fillFormWithAgent: function (agent) {
                if(agent){
                    this.invoiceToForm = {
                        id: agent.id,
                        vat: agent.vat? agent.vat : agent.taxpayerNumber,
                        city: agent.location,
                        country: agent.country,
                        businessName: agent.billingName? agent.billingName : agent.name,
                        address: agent.address
                    }
                }

                this.setCountry()
            },
            emitInvoices: function () {
                this.emitInvoiceBulk({
                    invoiceToForm: this.invoiceToForm,
                    invoiceTo: this.invoiceTo,
                    selectedAgent: this.selectedAgent
                }).then(response => {
                    let numberOfCreatedInvoices = response.data.length

                    if(response.data[0] != null && numberOfCreatedInvoices > 0){

                        this.$toasted.info(numberOfCreatedInvoices + 'Invoice/s created');

                        console.log('response', response);

                        for (let invoice of response.data) {
                            console.log('invoice', invoice);
                            this.printInvoice(invoice.id).then(response =>{
                                if(response.status == 200){
                                    this.openByteArrayNewTab(response.data)
                                    this.$emit('closeModal')
                                }

                            }).catch(err => {

                            })
                        }
                    }

                })
            },
            getInvoiceResume: function () {
                this.downloadReservationInvoiceResumeBulk({
                    invoiceToForm: this.invoiceToForm,
                    invoiceTo: this.invoiceTo
                }).then(response => {
                    if(response.status == 200){
                        this.invoiceResumeBulk = response.data
                    }
                })
            },
            // ------------  Helper  ------------
            selectedCountryChanged: function (e) {
                if(e){
                    this.invoiceToForm.country = e.id
                } else {
                    this.invoiceToForm.country = null
                }
            },
            sellerChanged: function (newSeller) {
                this.selectedAgent = newSeller
                this.fillFormWithAgent(newSeller)
            },
            setCountry: function (countryId) {


                if(!countryId && this.invoiceToForm.country){
                    countryId = this.invoiceToForm.country
                }

                if(typeof countryId == "object"){
                    countryId = countryId.id
                }

                console.log('countryId', countryId, this.invoiceToForm);
                if(countryId === undefined){
                    this.selectedCountry = null
                    return false
                }
                this.selectedCountry = this.getCountries.filter(country => {
                    return country.id == countryId
                })[0]
            },
        },
        components: {
            vSelect: extendedVSelect,
            SellerPicker,
            Loader
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// areaInvoice.vue?479813a2